export const fingerprintingFlag = true
export const bluetoothPairingFlag = true
export const essentialOnlyButtonsFlag = true
export const voiceColumnFlag = true
export const darkModeFlag = true
export const fleetVoiceFlag = true
